export default __webpack_public_path__ + "static/media/happyclient1.799017f3.svg";